import log from 'loglevel';
import { TriggerManager } from '../trigger-manager/trigger-manager';
import { PageContext, getPageContext } from '../browser-utilities/page-context';

interface TrackEventData { 
  event: string, 
  properties: any 
}

export default function(eventName: string, properties?: any): Promise<unknown> | void  {
  if (typeof eventName !== 'string') {
    log.error('track trigger: Must provide an event name.');
    return;
  }

  // custom handling for `Viewed Page` event
  if(eventName === 'Viewed Page') {
    return TriggerManager.eventRequest<{ type: string; properties: PageContext; }>('track', {
      type: 'page',
      properties: Object.assign(getPageContext(), properties)
    });
  }

  return TriggerManager.eventRequest<TrackEventData>('track', {
    event: eventName,
    properties: properties
  });
}
